var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleCenter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 44,
    viewBox: "0 0 740 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 738,
    height: 42,
    rx: 2,
    transform: "matrix(-1 0 0 1 738 0)",
    fill: "white",
    stroke: "#EBEFF6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleCenter3);
export default __webpack_public_path__ + "static/media/rectangleCenter3.b61f1a6c3c36e07a6d2b1eb40841ce3f.svg";
export { ForwardRef as ReactComponent };